import $ from 'jquery'

const $window = $(window)
const $sidebarTrigger = $('.js-sidebar-trigger')
const $sidebarNavButton = $('.sidebar__mobile-button')
const $sidebarActiveLink = $('.js-sidebar-link, .js-anchor-nav')
const stickyClass = 'is-sticky'
const activeClass = 'is-active'

function isScrolledTop($elem) {
    let elTop = $elem.offset().top

    return $window.scrollTop() >= elTop
}

$window.scroll(function() {

    // if sticky menu trigger is scrolled to
    if (isScrolledTop($sidebarTrigger)) {
        $sidebarNavButton.addClass(stickyClass)
        $sidebarTrigger.addClass(stickyClass)
    } else  {
        $sidebarNavButton.removeClass(stickyClass)
        $sidebarTrigger.removeClass(stickyClass)
    }
})

$(window).on('load resize scroll', function () {
    let windowTop = $window.scrollTop()
    let windowHeight = $window.innerHeight()
    let windowOffset = windowTop + (windowHeight / 4)
    
    $('.js-anchor-module').each(function () {
        const $this = $(this)
        let elTop = $this.offset().top
        let elBottom = $this.outerHeight() + elTop

        if (elTop < windowOffset && elBottom > windowOffset) {
            let id = $this.attr('id')
            let title = $this.attr('data-title')

            $sidebarActiveLink.removeClass(activeClass)
            $('a[href="#' + id + '"]').addClass(activeClass)

            if ( $(window).width() < 768 ) {
                $sidebarNavButton.text(title)
            }
        }
    });
})
